var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7743 6.03064V5.74346C11.7743 3.57742 11.7743 2.4944 11.1014 1.82149C10.4285 1.14859 9.34548 1.14859 7.1794 1.14859H6.6051C4.43909 1.14859 3.35608 1.14859 2.68318 1.82149C2.01028 2.49438 2.01026 3.57739 2.01025 5.74342L2.01022 8.32808C2.01021 10.2162 2.0102 11.1604 2.53167 11.7958C2.62715 11.9121 2.73384 12.0188 2.85018 12.1143C3.48562 12.6358 4.42971 12.6358 6.31786 12.6358",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30765 4.02039H9.47688",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30765 6.89221H7.7538",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7743 11.4868V9.76373C11.7743 8.94274 11.0029 8.04065 10.0512 8.04065C9.09956 8.04065 8.32814 8.94274 8.32814 9.76373V11.774C8.32814 12.2498 8.71388 12.6355 9.18968 12.6355C9.66548 12.6355 10.0512 12.2498 10.0512 11.774V9.76373",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentLink);
export default __webpack_public_path__ + "static/media/DocumentLink.712e978966c57c22afdb6b3147c7e020.svg";
export { ForwardRef as ReactComponent };